import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import instance from '@src/api/axiosInstance';

const deleteSchedule = async (scheduleId: number): Promise<any> => {
  const response = await instance.delete(`/nexa/schedule/delete/${scheduleId}`);
  return response.data;
};

export const useDeleteSchedule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteSchedule,
    onSuccess: (data) => {
      message.success(data?.message || 'Schedule deleted successfully');
      queryClient.invalidateQueries({ queryKey: ['nexa-schedule-list'] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message || 'Failed to delete schedule');
    },
  });
};
